

export const qualityEnum = ['Perfect', 'Imperfect', 'Defective'];
